// blog33.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../allcss/blog18.css";
import blogImage from "../Asets/Blog.jpg";
import detailImg from "../Asets/blog4343.png";
import Header from "../components/header";
import Footer from "../components/footer";

const Blog33 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={() => navigate("/")}
              >
                Home
              </span>
              <span>
                {" "}
                / Our Blog / How Safe Classrooms Encourage Better Learning Outcomes
              </span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            How Safe Classrooms Encourage Better Learning Outcomes
          </h2>

          <br />
          <div className="published-badge">
            Published on: 25 December 2025
          </div>
          <br />

          <img
            src={detailImg}
            alt="How Safe Classrooms Encourage Better Learning Outcomes"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">
            <p>
              A safe classroom is more than just a physical space — it is the
              foundation of effective learning in early childhood. At{" "}
              <strong>Red House School</strong>, known as the best play school in
              Harni, Vadodara, we believe that when children feel safe, secure,
              and comfortable, they learn better, grow confidently, and thrive
              emotionally.
            </p>

            <hr />

            <h3>🛡️ Why Safety Is Essential in Early Childhood Education</h3>
            <p>
              Preschool children are in a critical phase of development where
              emotional security directly affects learning. A safe classroom
              environment helps:
            </p>
            <ul>
              <li>Reduce fear and anxiety</li>
              <li>Build trust between children and teachers</li>
              <li>Encourage exploration and curiosity</li>
              <li>Promote emotional and social development</li>
              <li>Improve focus and participation</li>
            </ul>
            <p>
              A well-designed play school in Harni Vadodara prioritizes safety as
              much as academics.
            </p>

            <hr />

            <h3>🔗 The Link Between Safety and Better Learning Outcomes</h3>
            <p>Children learn best when they feel protected and supported.</p>
            <ul>
              <li>Encourage children to ask questions freely</li>
              <li>Help them participate confidently in group activities</li>
              <li>Support healthy risk-taking through play and creativity</li>
              <li>Improve attention span and memory</li>
              <li>Foster positive behavior and discipline</li>
            </ul>
            <p>
              At Red House School Vadodara, safety creates the confidence
              children need to learn joyfully.
            </p>

            <hr />

            <h3>🏫 What Makes a Classroom Safe for Preschoolers?</h3>
            <p>
              As a trusted play school in Harni, Red House School ensures safety
              through:
            </p>

            <p><strong>🛡️ Child-Friendly Infrastructure</strong></p>
            <p>
              Furniture, learning materials, and play equipment are designed to
              be safe and age-appropriate.
            </p>

            <p><strong>👩‍🏫 Caring & Trained Educators</strong></p>
            <p>
              Our teachers create a warm, respectful environment where every
              child feels valued and heard.
            </p>

            <p><strong>🧼 Clean & Hygienic Spaces</strong></p>
            <p>
              Regular cleaning and hygiene practices ensure a healthy learning
              atmosphere.
            </p>

            <p><strong>🧠 Emotional Safety</strong></p>
            <p>
              Children are encouraged to express themselves without fear,
              helping them build confidence and emotional intelligence.
            </p>

            <hr />

            <h3>🌱 How Safe Classrooms Support Holistic Development</h3>
            <p>
              A secure learning environment helps children develop:
            </p>
            <ul>
              <li>Social skills and teamwork</li>
              <li>Independence and responsibility</li>
              <li>Emotional stability</li>
              <li>Creativity and problem-solving abilities</li>
            </ul>
            <p>
              This holistic approach makes Red House School one of the most
              trusted choices for parents seeking a play school in Harni
              Vadodara.
            </p>

            <hr />

            <h3>❤️ Why Parents Choose Red House School, Harni Vadodara</h3>
            <p>Parents trust Red House School because we offer:</p>
            <ul>
              <li>A safe, nurturing, and child-friendly environment</li>
              <li>Focus on emotional, physical, and academic growth</li>
              <li>Experienced and caring educators</li>
              <li>Clean and well-maintained classrooms</li>
              <li>Convenient Harni location</li>
            </ul>

            <hr />

            <h3>📍 Contact & Location Details</h3>
            <p>
              <strong>Address:</strong> A-25, Castle White, Opposite Main, Harni
              Water Tank, Harni Sama Link Road, Vadodara – 390008
              <br />
              <strong>Mobile:</strong>{" "}
              <a href="tel:+917778851070">+91 77788 51070</a>
              <br />
              <strong>Email:</strong>{" "}
              <a href="mailto:redschoolhousebaroda2025@gmail.com">
                redschoolhousebaroda2025@gmail.com
              </a>
              <br />
              <strong>Website:</strong>{" "}
              <a
                href="https://www.redhouseschoolvadodara.in/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.redhouseschoolvadodara.in/
              </a>
              <br />
              <strong>Instagram:</strong>{" "}
              <a
                href="https://www.instagram.com/redschoolhousebaroda/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.instagram.com/redschoolhousebaroda/
              </a>
            </p>

            <p className="blog-tags">
              #SafeClassrooms &nbsp;
              #PlaySchoolInHarni &nbsp;
              #RedHouseSchoolVadodara &nbsp;
              #EarlyLearning &nbsp;
              #ChildSafety &nbsp;
              #HappyLearners
            </p>

            {/* Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate("/blog")}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Blog33;
